module.exports = __webpack_public_path__ + "img/page logo.c7d65b68.png";